import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {DashboardFacade} from '../store/dashboard.facade';

@Component({
  selector: 'app-lastsigneddocumentwidget',
  templateUrl: './lastsigneddocumentwidget.component.html',
  styleUrls: ['./lastsigneddocumentwidget.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LastsigneddocumentwidgetComponent implements OnInit {

  public fetchLastSignedDocuments$ = this.dashboardFacade$.lastSignedDocuments$;
  constructor(private dashboardFacade$ : DashboardFacade) { }

  ngOnInit(): void {
    this.dashboardFacade$.fetchLastSignedDocuments();
  }

}
